import angular from 'angular';
export const paymentCommonComponents = angular
    .module('paymentCommonComponents', [])
    .name;
